<template>
  <TouchLayout @upload-setting="uploadSetting">
        <div class='main'>
            <div class='reservation-area'>
                <!-- 예약정보 -->
                <div class='view-box'>
                    <div>
                        <div class='info-cnt'>
                            <div class='left-info'>
                                <div :style="{ backgroundImage: customerInfo.imageUrl ? 'url(' + customerInfo.imageUrl.replaceAll('(', '\\(').replaceAll(')', '\\)') + ')' : '' }" class='image-box'></div>
                                <div class='member-info'>
                                    <div class='hello'>
                                        <strong>{{ this.$route.query.name }}</strong>
                                        회원님, 반갑습니다!
                                    </div>
                                    <div class='box-phone'>
                                        <div class='phone'>
                                            {{ customerInfo.phone | phoneNumberSecurityFilter }}
                                        </div>
                                        <div v-if='!!customerInfo.centerLocker' class='use-locker'>
                                            락커 사용중
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class='box-right-info'>
                                <button class="right-info" @click='goTicket'>
                                    내 이용권보기
                                </button>
                            </div>
                        </div>
                        <div class='list-cnt'>
                            <button class='card attend' @click='goAttendance'>
                                <div class='box-txt'>
                                    <div class='txt1'>
                                        오늘 예약되어있는 수업 {{attendCount}}건
                                    </div>
                                    <div class='txt2'>
                                        출석하기
                                    </div>
                                </div>
                                <div class='icon'>
                                    <div class='attend-icon'>
                                    </div>
                                </div>
                            </button>
                            <button class='card entrance' @click='goEntrance'>
                                <div class='box-txt'>
                                    <div class='txt1'>
                                        회원권으로 시설 이용
                                    </div>
                                    <div class='txt2'>
                                        입장하기
                                    </div>
                                </div>
                                <div class='icon'>
                                    <div class='entrance-icon'>
                                    </div>
                                </div>
                            </button>
                        </div>
                    </div>
                    <div class='back'>
                        <div class='txt'>
                            회원 본인이 아닐 경우 ‘돌아가기' 버튼을 눌러주세요.
                        </div>
                        <button class='box-btn' @click='back'>
                            <span class='btn-txt'>돌아가기</span>
                            <div class='arrow-right'></div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    <!-- 출석성공 팝업 -->
    <attendance-alert
        v-if='isAttendanceSuccess'
        imgUrl='/img/icons/touch_success.png'
        :title='popTitle'
        :body='popBody'
        :body2='popBody2'
        body3='출석되었습니다. 오늘도 건강한 하루되세요!'
        :expireDays='popExpireDays'
        :lessonCountType='popLessonCountType'
        :lessonCount='popLessonCount'
        :contractSeq='popContractSeq'
        :isTimeLimit='true'
        @close-popup='onClickSuccess'
    />
    <!-- 출석 불가능 얼럿 -->
    <image-alert
        v-if='isOpenNoAttendPopup'
        imgUrl='/img/icons/touch_no_attendance.png'
        body1='예약되어있는 수업이 없습니다.'
        body2='다시 확인해주세요.'
        :isTimeLimit='true'
        @close-popup='onClickNoAttendAlert'
    />
    <!-- 입장성공 팝업 -->
    <entrance-alert
        v-if='isEntranceSuccess'
        imgUrl='/img/icons/touch_success.png'
        :title='popTitle'
        :body='popBody'
        :expireDays='popExpireDays'
        body2='입장되었습니다. 오늘도 건강한 하루되세요!'
        :isTimeLimit='true'
        @close-popup='onClickSuccess'
    />
    <!-- 입장 불가능 얼럿 -->
    <image-alert
        v-if='isOpenNoEntrancePopup'
        imgUrl='/img/icons/touch_no_entrance.png'
        body1='입장할 수 있는 이용권이 없습니다.'
        body2='다시 확인해주세요.'
        :isTimeLimit='true'
        @close-popup='onClickNoEntranceAlert'
    />
     <!-- 입장 불가능 얼럿 -->
     <image-alert
     v-if='isOpenOneNoEntrancePopup'
     imgUrl='/img/icons/touch_no_entrance.png'
     body1='일일 입장 1회 제한 입니다'
     body2='다시 확인해주세요.'
     :isTimeLimit='true'
     @close-popup='onClickOneNoEntranceAlert'
 />
  </TouchLayout>
</template>

<script>
import { Utils } from '@/assets/js/utils';
import moment from 'moment';
import api from '@/assets/js/api';
import TouchLayout from '@/layouts/TouchLayout';
import ImageAlert from '@/components/ImageAlert';
import ImageAlert2 from '@/components/ImageAlert2';
import AttendanceAlert from '@/components/AttendanceAlert';
import EntranceAlert from '@/components/EntranceAlert';

export default {
    name: 'touchReservationMain',
    components: {
      TouchLayout,
      ImageAlert,
      ImageAlert2,
      AttendanceAlert,
      EntranceAlert,
    },
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    data() {
        return {
            nowDate: moment().format('YYYY.MM.DD'),
            today: moment().format('YYYY-MM-DD'),
            nowTime: moment().format('hh:mm:ss'),
            centerCustomerId: this.$route.query.custId,
            centerCustomerName: this.$route.query.name,
            reserveList: '',
            customerInfo: {}, // 회원 정보
            centerId: this.$route.query.centerId,
            attendCount: 0,
            entranceCount: 0,
            entranceTicket: {},
            isOpenNoAttendPopup: false,
            isOpenNoEntrancePopup: false,
            isAttendanceSuccess: false,
            isEntranceSuccess: false,
            popTitle: '',
            popBody: '',
            popBody2: '',
            popExpireDays: 0,
            popLessonCountType: '',
            popLessonCount: 0,
            popContractSeq: 0,
            cardInfo: {},
            setting: {},
            isOpenOneNoEntrancePopup: false,
        };
    },
    created() {
    },
    mounted() {
        setInterval(
            () => {
                this.nowTime = moment().format('hh:mm:ss');
            }
            , 1000,
        );
        Promise.allSettled([
            this.fetchCustomerDetail(), // 회원정보 가져오기
            this.onSearchList()
        ]);
        this.speak('');
    },
    methods: {
        back() {
            this.$router.push({ path: '/touch/main' }); // 뒤로가기
        },
        async onSearchList() {
            try {
                const { data } = await this.getSearchLsit();
                console.log("onSearchList: ", data);
                this.reserveList = data;

                if (!this.reserveList || this.reserveList.length === 0) {
                    /*
                    this.$router.replace({
                        path: 'nodata',
                        query: {
                            name: this.centerCustomerName,
                        },
                    });
                    */
                }else {
                    for(const reserve of this.reserveList) {
                        // 출석 카운트
                        if( moment(reserve.lessonDate).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD') && reserve.ticketType != 'S' && reserve.expirePlusType !== 'H' && reserve.centerLessonScheduleId) {
                            this.attendCount++;
                        }

                        // 입장 카운트
                        if( reserve.ticketType != 'S' && reserve.expirePlusType !== 'H' && ((reserve.ticketType === 'T') || (reserve.ticketType !== 'T' && !reserve.lessonDate && !reserve.noReservationEnterYn)) ) {
                            if( moment().format('YYYY-MM-DD') >= moment(reserve.expireStartDate).format('YYYY-MM-DD') && moment().format('YYYY-MM-DD') <= moment(reserve.expireEndDate).format('YYYY-MM-DD') ) {
                                this.entranceCount++;
                                this.entranceTicket = reserve;
                            }
                        }
                    }
                }
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        getSearchLsit() {
            return api.get(`/admin/api/center/${this.cId}/touch/monitor/customer/${this.centerCustomerId}/schedule/list`);
        },
        // 회원 정보 가져오기
        async fetchCustomerDetail() {
            try {
                const { data } = await this.sendGetCustomerDetail();
                this.customerInfo = data;
                for(let i in this.customerInfo.centerLockers) {
                    if(this.customerInfo.centerLockers[i].lockerStatus != 'F') {
                        this.customerInfo.centerLocker = this.customerInfo.centerLockers[i];
                        const rentEndedDay = moment(this.customerInfo.centerLocker.rentEndedAt);
                        const currentDate = moment();
                        this.customerInfo.centerLocker.rentRemainDays = rentEndedDay.diff(currentDate,"days")
                        // return (remainDays >= 0) ? `-${remainDays}` : String(remainDays).replace('-', '+');

                        break;
                    }
                }
            } catch (error) {
                alert('회원정보를 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },
        // 회원 기본정보 조회 API 호출
        sendGetCustomerDetail() {
            return api.get(`/admin/api/center/${this.centerId}/customer/${this.centerCustomerId}`);
        },
        goTicket() {
            this.$router.push({
                path: '/touch/reservation/ticket',
                query: {
                    centerId: this.centerId,
                    custId: this.centerCustomerId,
                    name: this.centerCustomerName,
                },
            });
        },
        goAttendance() {
            if(this.attendCount < 1) {
                this.isOpenNoAttendPopup = true;
                if(this.setting.soundOption != 'N') {
                    // 알림음 송출화면 체크
                    if( this.setting.soundFrom == 'T' ) {
                        if(this.setting.soundOption == 'S') {
                            this.speak('예약 된 수업이 없습니다.');
                        }else if(this.setting.soundOption == 'M') {
                            this.playAudio('invalid_attendance_entrance.mp3');
                        }
                    }else if( this.setting.soundFrom == 'A' ) {
                        this.callSound(this.setting.soundOption, 'F', '예약 된 수업이 없습니다.');
                    }else if( this.setting.soundFrom == 'B' ) {
                        if(this.setting.soundOption == 'S') {
                            this.speak('예약 된 수업이 없습니다.');
                        }else if(this.setting.soundOption == 'M') {
                            this.playAudio('invalid_attendance_entrance.mp3');
                        }
                        this.callSound(this.setting.soundOption, 'F', '예약 된 수업이 없습니다.');
                    }
                }
            //}else if(this.attendCount == 1) {
            //    this.touchAttendance(this.reserveList[0]);
            }else {
                this.$router.push({
                    path: '/touch/reservation/attendance',
                    query: {
                        centerId: this.centerId,
                        custId: this.centerCustomerId,
                        name: this.centerCustomerName,
                    },
                });
            }
        },
        goEntrance() {
            if(this.entranceCount < 1) {
                this.isOpenNoEntrancePopup = true;
                if(this.setting.soundOption != 'N') {
                    // 알림음 송출화면 체크
                    if( this.setting.soundFrom == 'T' ) {
                        if(this.setting.soundOption == 'S') {
                            this.speak('입장 가능한 이용권이 없습니다.');
                        }else if(this.setting.soundOption == 'M') {
                            this.playAudio('invalid_attendance_entrance.mp3');
                        }
                    }else if( this.setting.soundFrom == 'A' ) {
                        this.callSound(this.setting.soundOption, 'F', '입장 가능한 이용권이 없습니다.');
                    }else if( this.setting.soundFrom == 'B' ) {
                        if(this.setting.soundOption == 'S') {
                            this.speak('입장 가능한 이용권이 없습니다.');
                        }else if(this.setting.soundOption == 'M') {
                            this.playAudio('invalid_attendance_entrance.mp3');
                        }
                        this.callSound(this.setting.soundOption, 'F', '입장 가능한 이용권이 없습니다.');
                    }
                }
            }else if(this.entranceCount == 1) {
                this.touchEntrance(this.entranceTicket);
            }else {
                this.$router.push({
                    path: '/touch/reservation/entrance',
                    query: {
                        centerId: this.centerId,
                        custId: this.centerCustomerId,
                        name: this.centerCustomerName,
                    },
                });
            }
        },
        onClickNoAttendAlert() {
            this.isOpenNoAttendPopup = false;
        },
        onClickNoEntranceAlert() {
            this.isOpenNoEntrancePopup = false;
        },
        async touchAttendance(r) {
            // 팝업
            this.popTitle = `${this.convertTicket(r.ticketType)} ${r.productName}`;
            this.popBody = `${this.timestampFilter5(r.lessonDate)} ${this.timeCutter(r.lessonStartTime)} ~ ${this.timeCutter(r.lessonEndTime)} ${!r.centerRoomNames ? '' : `ROOM ${r.centerRoomNames}`}`;
            this.popBody2 = `${this.timestampFilter4(r.expireStartDate)} ~ ${this.timestampFilter4(r.expireEndDate)}`;
            this.popExpireDays = r.expireDays;
            this.popLessonCountType = r.lessonCountType;
            this.popLessonCount = r.lessonCount;
            this.popContractSeq = r.contractSeq;

            // 카드
            this.cardInfo.cardCustomerName = `${r.centerCustomerName}`;
            this.cardInfo.cardProductCheckType = `출석`;
            this.cardInfo.cardCustomerImageUrl = this.customerInfo.imageUrl;
            this.cardInfo.cardProductName = `${this.convertTicket(r.ticketType)} ${r.productName}`;
            this.cardInfo.cardProductExpireDate = `이용권 만료일 ${this.timestampFilter(r.expireEndDate)}`;

            const c = r.centerContractId;
            const p = r.centerProductId;
            const l = r.centerLessonScheduleId;

            try {
                const { data } = await this.fetchTouchAttendance(c, p, l);
                console.log('data', data);
                if (data == true) {
                    this.isAttendanceSuccess = true;
                } else {
                    alert('출석 승인되지 않았습니다.');
                }
            } catch (e) {
                console.error(e);
                console.log('터치 에러입니다.');
            }
        },
        fetchTouchAttendance(c, p, l) { // 회원권이 아닌 경우
            return api.put(`/admin/api/center/${this.cId}/touch/monitor/customer/${this.centerCustomerId}/touch/attend`, {
                centerContractId: c,
                centerProductId: p,
                centerLessonScheduleId: l,
            });
        },
        async touchEntrance(r) {
            // 팝업
            this.popTitle = this.convertTicket(r.ticketType) + r.productName;
            this.popBody = `${this.timestampFilter4(r.expireStartDate)} ~ ${this.timestampFilter4(r.expireEndDate)}`;
            this.popExpireDays = r.expireDays;

            // 카드
            this.cardInfo.cardCustomerName = `${r.centerCustomerName}`;
            this.cardInfo.cardProductCheckType = `입장`;
            this.cardInfo.cardCustomerImageUrl = this.customerInfo.imageUrl;
            this.cardInfo.cardProductName = `${this.convertTicket(r.ticketType)} ${r.productName}`;
            this.cardInfo.cardProductExpireDate = `이용권 만료일 ${this.timestampFilter(r.expireEndDate)}`;
            //console.log(this.cardInfo);

            const c = r.centerContractId;
            const p = r.centerProductId;
            const l = r.centerLessonScheduleId;

            try {
                const { data } = await this.fetchTouchEntrance(c, p, l);
                let  {rc, rm} = data;
                if (rc === true) {
                    this.isEntranceSuccess = true;
                    if(this.setting.openCardYn) {
                        this.callCard();
                    }
                    if(this.setting.soundOption != 'N') {
                        let soundType = 'T';
                        let speakMessage = "입장 완료 되었습니다.";
                        let count = 0;

                        // 이용권 잔여횟수
                        if(r.lessonCountType === 'T') {
                            if(!r.contractSeq ) {
                                count = r.lessonCount;
                            }else {
                                count = r.lessonCount - r.contractSeq;
                            }
                        }else if(r.lessonCountType === 'W') {
                            count = r.lessonCount;
                        }else if(r.lessonCountType === 'U') {
                            count = 1000;
                        }

                        // 만료 알림음 조건
                        if( r.expireDays <= 7 || count <= 3 ) {
                            soundType = 'E';
                            speakMessage = "입장 완료 되었습니다. 이용권이 곧 종료 예정입니다.";
                        }

                        // 알림음 송출화면 체크
                        if( this.setting.soundFrom == 'T' ) {
                            if(this.setting.soundOption == 'S') {
                                this.speak(speakMessage);
                            }else if(this.setting.soundOption == 'M') {
                                if(soundType == 'T') {
                                    this.playAudio('attendance_entrance.mp3');
                                }else if(soundType == 'F') {
                                    this.playAudio('invalid_attendance_entrance.mp3');
                                }else if(soundType == 'E') {
                                    this.playAudio('expiring_attendance_entrance.mp3');
                                }
                            }
                        }else if( this.setting.soundFrom == 'A' ) {
                            this.callSound(this.setting.soundOption, soundType, speakMessage);
                        }else if( this.setting.soundFrom == 'B' ) {
                            if(this.setting.soundOption == 'S') {
                                this.speak(speakMessage);
                            }else if(this.setting.soundOption == 'M') {
                                if(soundType == 'T') {
                                    this.playAudio('attendance_entrance.mp3');
                                }else if(soundType == 'F') {
                                    this.playAudio('invalid_attendance_entrance.mp3');
                                }else if(soundType == 'E') {
                                    this.playAudio('expiring_attendance_entrance.mp3');
                                }
                            }
                            this.callSound(this.setting.soundOption, soundType, speakMessage);
                        }
                    }
                } else {
                    rm = rm || '입장하지 못했습니다.';
                    if(this.setting.soundOption != 'N') {
                        this.speak(rm);
                    }
                    this.isOpenOneNoEntrancePopup = true;
                }
            } catch (e) {
                console.error(e);
                console.log('터치 에러입니다.');
            }
        },
        fetchTouchEntrance(c, p, l) {
            return api.post(`/admin/api/center/${this.cId}/touch/monitor/customer/${this.centerCustomerId}/touch/entrance`, {
                centerContractId: c,
                centerProductId: p,
                centerLessonScheduleId: l,
            });
        },
        onClickSuccess() {
            this.isAttendanceSuccess = false;
            this.isEntranceSuccess = false;
            this.$router.push({ path: '/touch/main' });
        },
        convertTicket(val) {
            switch (val) {
                case 'P':
                    return '[개인]';
                    break;
                case 'O':
                    return '[OT]';
                    break;
                case 'D':
                    return '[듀엣]';
                    break;
                case 'G':
                    return '[그룹]';
                    break;
                case 'T':
                    return '[회원권]';
                    break;
            }
        },
        // timestampTZ -> date (년-월-일)
        timestampFilter(value) {
            if (value === null || value === '' || value === undefined) {
                return value;
            }

            function addZero(target) {
                // 9 이하의 숫자는 0 붙이기
                const num = parseInt(target);
                const str = num > 9 ? num : `0${num}`;
                return str.toString();
            }

            const b = value.split(/\D/);
            --b[1];
            b[6] = b[6].substr(0, 3);
            const d = new Date(Date.UTC(...b));
            return `${d.getFullYear()}-${addZero(d.getMonth() + 1)}-${addZero(d.getDate())}`;
        },
        // timestampTZ -> date (년.월.일)
        timestampFilter4(value) {
            if (value === null || value === '' || value === undefined) {
                return value;
            }

            function addZero(target) {
                // 9 이하의 숫자는 0 붙이기
                const num = parseInt(target);
                const str = num > 9 ? num : `0${num}`;
                return str.toString();
            }

            const b = value.split(/\D/);
            --b[1];
            b[6] = b[6].substr(0, 3);
            const d = new Date(Date.UTC(...b));

            return `${d.getFullYear()}. ${addZero(d.getMonth() + 1)}. ${addZero(d.getDate())}`;
        },
        // timestampTZ -> date (년.월.일)(요일)
        timestampFilter5(value) {
            if (value === null || value === '' || value === undefined) {
                return value;
            }

            function addZero(target) {
                // 9 이하의 숫자는 0 붙이기
                const num = parseInt(target);
                const str = num > 9 ? num : `0${num}`;
                return str.toString();
            }

            const b = value.split(/\D/);
            --b[1];
            b[6] = b[6].substr(0, 3);
            const d = new Date(Date.UTC(...b));

            const date1 = `${d.getFullYear()}-${addZero(d.getMonth() + 1)}-${addZero(d.getDate())}`;
            const date2 = `${d.getFullYear()}.${addZero(d.getMonth() + 1)}.${addZero(d.getDate())}`;

            return `${date2}(${Utils.getDayOfWeekName(date1)})`;
        },
        timeCutter(value) {
            if (value === null || value === '' || value === undefined) {
                return value;
            }
            const date = value.substr(0, 5);
            return date;
        },
        callCard() {
            return api.post(`${process.env.VUE_APP_SSE_URL}/sse/touch/monitor/alert/card`, {
                centerId: this.centerId,
                cardInfo: this.cardInfo,
            });
        },
        callSound(soundOption, soundType, speakMessage) {
            return api.post(`${process.env.VUE_APP_SSE_URL}/sse/touch/monitor/alert/sound`, {
                centerId: this.centerId,
                soundInfo: {soundOption, soundType, speakMessage},
            });
        },
        uploadSetting(data) {
            this.setting = data;
        },
        playAudio(filename) {
            const audio = new Audio(`/audio/${filename}`);
            audio.play().catch(error => {
            console.error('Audio playback failed:', error);
            });
        },
        speak(text) {
            const utterance = new SpeechSynthesisUtterance(text);
            window.speechSynthesis.speak(utterance);
        },
        onClickOneNoEntranceAlert() {
            this.isOpenOneNoEntrancePopup = false;
        },
    },
};
</script>

<style lang='scss' scoped>

    .member-info {
        display: flex;
        flex-direction: column;
        gap: 8px;

        // 라지 (가로 해상도가 1200px 보다 큰 화면에 적용)
        @media (min-width: 1200px) {
            gap:1.2rem;
        }
    }

    .hello {
        font-family: Pretendard;
        font-size: 2.4rem;
        font-weight: 700;
        line-height: normal;
        letter-spacing: -0.6000000238418579px;
        text-align: left;
        color: #535353;

        // 라지 (가로 해상도가 1200px 보다 큰 화면에 적용)
        @media (min-width: 1200px) {
            font-size: 2.4rem;
            liine-height: 2.4rem;
        }

        strong {
            color: #0078F4;
        }
    }

    .box-phone {
        display: flex;
        align-items: center;
        gap: 8px;

        // 라지 (가로 해상도가 1200px 보다 큰 화면에 적용)
        @media (min-width: 1200px) {
            gap: 0.8rem;
        }

        .phone {
            font-family: Noto Sans CJK KR;
            font-size: 1.6rem;
            font-weight: 400;
            line-height: normal;
            letter-spacing: -0.6000000238418579px;
            text-align: left;
            color: #535353;

            // 라지 (가로 해상도가 1200px 보다 큰 화면에 적용)
            @media (min-width: 1200px) {
                font-size: 1.6rem;
                line-height:1.6rem;
            }
        }

        .use-locker {
            font-family: Noto Sans CJK KR;
            font-size: 20px;
            font-weight: 500;
            line-height: 24px;
            letter-spacing: -0.005em;
            text-align: center;
            color: #0078F4;
            padding: 4px 12px 4px 12px;
            border-radius: 16px;
            border: 1px solid #0078F4;

            // 라지 (가로 해상도가 1200px 보다 큰 화면에 적용)
            @media (min-width: 1200px) {
                font-size: 1.4rem;
                line-height: 1.6rem;
                border: 2px solid #0078f4;
            }
        }
    }

    .card {
        display: flex;
        flex-direction: column;
        height: 256px;
        padding: 32px 40px 32px 40px;
		width: calc( (100% - 16px) / 2);

        // 태블릿 (가로 해상도가 992px 보다 작은 화면에 적용)
        @media (max-width: 991px) {
            width: 100%;
            height: 206px;
            flex-direction: row;
            align-items: center;
        }

        &.attend {
            background-color: #36BBF9;

            // 라지 (가로 해상도가 1200px 보다 큰 화면에 적용)
            @media (min-width: 1200px) {
                height: 80%;
                justify-content: space-around;
            }

            .attend-icon {
                width: 96px;
                height: 96px;
                background: url(/img/icons/touch_attend.png) no-repeat;
                background-position: center !important;

                // 라지 (가로 해상도가 1200px 보다 큰 화면에 적용)
                @media (min-width: 1200px) {
                    width: 8rem;
                    height: 8rem;
                    background-size: contain;
                }
            }
        }

        &.entrance {
            background-color: #0078F4;

            // 라지 (가로 해상도가 1200px 보다 큰 화면에 적용)
            @media (min-width: 1200px) {
                height: 80%;
                justify-content: space-around;
            }

            .entrance-icon {
                width: 96px;
                height: 96px;
                background: url(/img/icons/touch_entrance.png) no-repeat;
                background-position: center !important;

                // 라지 (가로 해상도가 1200px 보다 큰 화면에 적용)
                @media (min-width: 1200px) {
                    width: 8rem;
                    height: 8rem;
                    background-size: contain;
                }
            }
        }

        .icon {
            width: 100%;
            display: flex;
            justify-content: flex-end;
            margin-top: 8px;

            // 태블릿 (가로 해상도가 769px 보다 작은 화면에 적용)
            @media (max-width: 768px) {
                width: auto;
            }

            // 라지 (가로 해상도가 1200px 보다 큰 화면에 적용)
            @media (min-width: 1200px) {
                margin-top: 0;
            }
        }

        .box-txt {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: baseline;
        }

        .txt1 {
            font-family: Noto Sans CJK KR;
            font-size: 24px;
            font-weight: 400;
            line-height: 24px;
            letter-spacing: -0.005em;
            text-align: center;
            color: #ffffff;

            // 라지 (가로 해상도가 1200px 보다 큰 화면에 적용)
            @media (min-width: 1200px) {
                font-size: 1.6rem;
                line-height: 1.6rem;
            }
        }

        .txt2 {
            font-family: Noto Sans CJK KR;
            font-size: 48px;
            font-weight: 700;
            line-height: 48px;
            letter-spacing: -0.005em;
            text-align: center;
            color: #ffffff;
            margin-top: 16px;

            // 라지 (가로 해상도가 1200px 보다 큰 화면에 적용)
            @media (min-width: 1200px) {
                font-size: 3.2rem;
                line-height: 3.2rem;
                margin-top: 1.6rem;
            }
        }
    }

    .back {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 24px;
        border-top: 1px solid #DFDFDF;
        padding-top: 16px;

        .txt {
            font-family: Noto Sans CJK KR;
            font-size: 1.4rem;
            font-weight: 400;
            line-height: normal;
            letter-spacing: -0.6000000238418579px;
            text-align: left;
            color: #777777;

            // 라지 (가로 해상도가 1200px 보다 큰 화면에 적용)
            @media (min-width: 1200px) {
                font-size: 1.4rem;
                line-height: 2.4rem;
            }
        }

        .box-btn {
            display: flex;
        }

        .btn-txt {
            font-family: Pretendard;
            font-size: 1.4rem;
            font-weight: 600;
            line-height: normal;
            letter-spacing: -0.005em;
            text-align: center;
            color: #555555;

            // 라지 (가로 해상도가 1200px 보다 큰 화면에 적용)
            @media (min-width: 1200px) {
                font-size: 1.4rem;
                line-height: 2.4rem;
            }
        }

        .arrow-right {
            width: 24px;
            height: 24px;
            background: url(/img/icons/arrow_right.png) no-repeat;
            background-position: center !important;

            // 라지 (가로 해상도가 1200px 보다 큰 화면에 적용)
            @media (min-width: 1200px) {
                width: 2.4rem;
                height: 2.4rem;
            }
        }
    }

</style>
